import { BadgeProps } from "@chakra-ui/layout";
import Badge from "../Badge";
import { PurchaseOrderStatus } from "../../types/purchase_orders.types";

const PurchaseOrderStatusBadge = ({
  status,
  ...props
}: { status: PurchaseOrderStatus } & BadgeProps) => {
  const generateBadge = (
    textColor: string,
    borderColor: string,
    backgroundColor: string,
    label: string
  ) => {
    return (
      <Badge
        h="29px"
        w="fit-content"
        lineHeight="29px"
        fontSize="14px"
        fontWeight="500"
        px="12px"
        rounded="xl"
        backgroundColor={backgroundColor}
        color={textColor}
        border={"solid 1px"}
        borderColor={borderColor}
        textAlign="center"
        ml={props.ml}
      >
        {label}
      </Badge>
    );
  };
  const mapping = new Map<string, [string, string, string, string]>([
    [PurchaseOrderStatus.BLOCKED, ["red.700", "red.200", "red.50", "Bloqué"]],
    [PurchaseOrderStatus.DELIVERED, ["green.700", "green.200", "green.50", "Livré"]],
    [
      PurchaseOrderStatus.IN_DELIVERY,
      ["#334155", "#E2E8F0", "#F8FAFC", "En livraison"],
    ],
    [PurchaseOrderStatus.READY, ["#334155", "#E2E8F0", "#F8FAFC", "Prêt"]],
  ]);
  const statusMapping = mapping.get(status);
  if (!statusMapping) {
    return <>---</>;
  }
  return generateBadge(...statusMapping);
};

export default PurchaseOrderStatusBadge;
